var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e7VyGK2MPtc1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170 160",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "4cc5467e2670473a9649fcb22a030c27",
    "export-id": "a5c5ef7a75654f168cfba0b27201ffe3",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc136-fill",
    x1: 696.552,
    y1: 527.344,
    x2: 683.75,
    y2: 494.552,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc136-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc136-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc139-fill",
    x1: 752.873,
    y1: 521.417,
    x2: 682.73,
    y2: 429.416,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc139-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc139-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc141-fill",
    x1: 677.167,
    y1: 535.748,
    x2: 661.183,
    y2: 508.667,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc141-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc141-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc144-fill",
    x1: 643.719,
    y1: 527.662,
    x2: 630.549,
    y2: 505.349,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc144-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc144-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc147-fill",
    x1: 644.146,
    y1: 553.094,
    x2: 629.945,
    y2: 529.004,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc147-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc147-fill-1",
    offset: "85.6%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc148-fill",
    x1: 597.608,
    y1: 557.702,
    x2: 635.915,
    y2: 601.733,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc148-fill-0",
    offset: "32.5%",
    stopColor: "#d86257"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc148-fill-1",
    offset: "100%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc149-fill",
    x1: 700.915,
    y1: 512.759,
    x2: 691.662,
    y2: 485.001,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc149-fill-0",
    offset: "12.8%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc149-fill-1",
    offset: "52.9%",
    stopColor: "#ed956e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc151-fill",
    x1: 601.756,
    y1: 495.901,
    x2: 629.925,
    y2: 524.744,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc151-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc151-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc152-fill",
    x1: 638.367,
    y1: 497.154,
    x2: 654.021,
    y2: 511.975,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc152-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc152-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc162-fill",
    x1: 690.453,
    y1: 518.331,
    x2: 674.346,
    y2: 502.666,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc162-fill-0",
    offset: "1.9%",
    stopColor: "#d65764"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc162-fill-1",
    offset: "63%",
    stopColor: "#ffc6a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc165-fill",
    x1: 654.701,
    y1: 456.96,
    x2: 620.613,
    y2: 456.96,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc165-fill-0",
    offset: "5.6%",
    stopColor: "#ffddc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc165-fill-1",
    offset: "77.1%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc172-fill",
    x1: 642.284,
    y1: 509.006,
    x2: 650.203,
    y2: 522.151,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc172-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc172-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc178-fill",
    x1: 611.77,
    y1: 510.429,
    x2: 618.43,
    y2: 521.484,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc178-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc178-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc184-fill",
    x1: 636.076,
    y1: 537.469,
    x2: 627.844,
    y2: 553.711,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc184-fill-0",
    offset: "4%",
    stopColor: "#b22842"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc184-fill-1",
    offset: "21.3%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc184-fill-2",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc185-fill",
    x1: 646.632,
    y1: 535.249,
    x2: 643.627,
    y2: 535.249,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc185-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc185-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7VyGK2MPtc187-fill",
    x1: 638.364,
    y1: 534.479,
    x2: 632.934,
    y2: 545.193,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc187-fill-0",
    offset: "4%",
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7VyGK2MPtc187-fill-1",
    offset: "99.5%",
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.29036 0 0 0.356739-85.519448-120.753808)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M591.5,728.9C590,735.8,585,774,585,774h125.8c0,0-5.7-31.6-10.6-46.7l-108.7,1.6Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M632.5,773.5q0,0,0,0c-.7,0-1.2-.5-1.2-1.2l.4-33.4c0-.6.5-1.1,1.2-1.1q0,0,0,0c.7,0,1.2.5,1.2,1.2l-.4,33.3c0,.7-.6,1.2-1.2,1.2Z",
    fill: "#d4bfb9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M704.8,761.4c-4,0-12.7-.6-21-5.5-10.9-6.4-16.7-19.3-16.9-19.9-.3-.6,0-1.3.6-1.5.5-.3,1.2,0,1.5.6.1.1,5.7,12.8,16,18.8s21.7,5.1,21.8,5.1c.6-.1,1.2.4,1.3,1c0,.7-.5,1.2-1.1,1.3-.1,0-.9.1-2.2.1Z",
    fill: "#d4bfb9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M588.7,757.1c-.5,0-1-.4-1.2-.9-.1-.6.3-1.3,1-1.4.5-.1,13.3-3,15.2-20.9.1-.7.7-1.1,1.3-1.1.7.1,1.2.7,1.1,1.3-2.2,19.7-17,23-17.2,23q-.1,0-.2,0Z",
    fill: "#d4bfb9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M591.5,719.1v9.8c0,0,19.6,11.4,53.8,9.4c38.5-2.2,54.9-11,54.9-11l-2.8-10.8-105.9,2.6Z",
    fill: "#625153"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M642.1,741.2q0,0,0,0l-18.3-.8c-.9,0-1.5-.7-1.5-1.6l.5-13.6c0-.4.2-.8.5-1.1s.7-.4,1.1-.4l18.3.8c.9,0,1.5.8,1.5,1.6l-.5,13.6c0,.4-.2.8-.5,1.1s-.7.4-1.1.4Zm-16.6-3.8l15.1.6.4-10.4-15.1-.7-.4,10.5Z",
    fill: "#ffcf83"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M614.4,739.5h-4.7l.6-16h4.7l-.6,16Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.7,736.1h-4.7l.6-16h4.7l-.6,16Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.3,740.5h-4.7l.6-15.9h4.7l-.6,15.9Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.9,732.4h-4.7l.5-15.9h4.7l-.5,15.9Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.8,581.4c-37.1,18.5-69.7,57.8-69.7,57.8s-15.7,15.6-20.8,27.5c-5,11.9-8.2,28.1,6.3,36c16.2,8.9,58.3-13.4,78.7-37c17-19.6,5.5-84.3,5.5-84.3Z",
    fill: "#d25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.3,571c-19.7,2.7-35.5,10.4-35.5,10.4-1.7,2.7-3.9,6.6-6.1,11.6-5.2,12.2-6.4,22.8-7.1,32-1.5,18.3-.9,27.9-1,50.4c0,34.8-.6,37.2,2.6,42.8c2.9,5.4,29.9,11.8,52.9,11.2s49.4-7.3,53.3-12.9c3.6-5.3,3-8.3,5.3-32.9c2.3-23.8,5-42.3,6.7-51.8c2-11,5.6-27.4,12.9-47.2-15.3-5.9-28.6-9.8-38.6-10.9-8.6-.9-31.3-4.7-45.4-2.7Z",
    fill: "#d25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.3,584.6c43.8,17.7,92.6,55.9,99.1,70.9c6.7,15.3-5.9,35.7-21.6,36.9c0,0-16.7,2.6-37-20.5c0,0-43.7-23.1-64.5-24.2l24-63.1Z",
    fill: "#d25a5a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M762.8,673.1q-.2,0-.5-.2c-.4-.2-43.7-22.9-64.1-24-.7-.1-1.2-.6-1.1-1.3c0-.6.6-1.1,1.2-1.1c20.9,1.2,63.3,23.4,65.1,24.3.6.4.8,1.1.5,1.6-.2.4-.6.7-1.1.7Z",
    fill: "#bc4d4d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M555.7,673c-.2,22.9-11.5,33.8-29.7,34.1-13.3.1-25.4-10.3-24.5-31.5.9-17.5,15.5-31.7,28.8-31.7s25.6,12.2,25.4,29.1Z",
    fill: "#bc4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784,643.8c21.7-12.3,40.3,1,43.9,16.7c3.6,15.1-5.9,33-28.2,37.7-17.1,3.6-33.2-3.3-37.1-16-4-12.7,6.7-30.1,21.4-38.4Z",
    fill: "#bc4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488,576.4c0,0,25,49.8,43.6,73.2c16.6,21,8.6,50.3-10,49.3-15.2-.9-24.6-17.8-32.8-43.8-7-22-12.4-59.7-21.7-67.7l20.9-11Z",
    fill: "#ffb88c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M488,576.4c-4.3-7.7-9.5-12.5-15.8-15.8-6.4-3.2-12.9-8.2-15.3-6.6-2.3,1.7,9.8,11.8,9.8,11.8s-5.9,1.3-14.6.1c-8.6-1.3-16.8-11.5-19.9-10.8s.5,4.9.5,4.9-4.8-5.5-7.1-3.5s4.1,9.1,4.1,9.1-3-1.8-3.9.1c-.9,1.8,5.3,10.4,18.5,14.8c13.3,4.3,18.9,4.1,22.8,6.9c3.8,2.8,27.4.8,20.9-11Z",
    fill: "#ffb88c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M478.4,579.6c-.2,0-.5-.1-.7-.3c0-.1-2.6-3.1-5.3-3.6-.5-.1-.9-.6-.8-1.1s.6-.8,1.1-.7c3.4.6,6.3,4,6.4,4.2.4.3.3.9-.1,1.2q-.2.3-.6.3Z",
    fill: "#e4807c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M444.2,569.2q-.2,0-.3-.1c-5.1-1.8-11.6-8.2-11.9-8.4-.3-.4-.3-1,0-1.3.4-.4,1-.4,1.3,0c.1,0,6.5,6.3,11.2,8c.5.2.7.7.5,1.2-.1.3-.4.6-.8.6Z",
    fill: "#e4807c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M442.6,574.8q-.1,0-.3,0c-6.5-2.1-13-8.2-13.2-8.5-.4-.4-.4-.9-.1-1.3.4-.4,1-.4,1.3,0c.1,0,6.5,6.1,12.6,8c.5.2.7.7.6,1.2-.1.4-.5.6-.9.6Z",
    fill: "#e4807c"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M780.3,659.1c-22.8,14.1-48.6,52.1-66.5,53.3l9.5,19.9c0,0,56-19,82.7-40.9c0,0,20.9-18.5,11.2-34.2-6.8-10.9-24.9-5.5-36.9,1.9Z",
    fill: "#ffb88c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M591.2,719.4c-.2,0-.6-.1-.9-.4q-.1-.1-.2-.2c-1.8-3.3-1.8-13.3-1.8-23.9-.1-7.5.6-79.8,1.2-79.5.5.2.6,1.2.6,1.5.2,3-1,54.7-.3,58.3.8,4.3.8,11.8.8,19.7c0,1.3,2.4,19.3,1.6,22.7-.1.2-.4,1.7-1,1.8Z",
    fill: "#bc4d4d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M583.2,631.6c-.5,0-.9-.3-1.1-.7-1.4-3.6-.6-11.5-.6-11.8.1-.7.7-1.1,1.3-1.1.7.1,1.1.7,1.1,1.3-.3,2.1-.6,8.2.4,10.7.2.6-.1,1.3-.7,1.5q-.2.1-.4.1Z",
    fill: "#bc4d4d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M701.4,654.4c-.5,0-1-.4-1.1-.9-.2-.6.1-1.2.7-1.4.3-.1,6.6-2,11.8-2c.6,0,1.1.5,1.1,1.1c0,.7-.5,1.2-1.1,1.2-4.9,0-11,1.9-11.1,1.9q-.1.1-.3.1Z",
    fill: "#bc4d4d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M713.8,712.4c-5.9,1-12.8-2.1-17.1-.8-2.9.9-5.3,6.7-5.3,6.7s-6.2,1.8-6.7,4.7c-.5,3,2,4.9,2,4.9s-1.8,2.3-1.2,4.6c.6,2.1,4.5,3.8,4.5,3.8s-.3,2.7,2.1,4.7c3.1,2.6,20.9-.1,31.3-8.6c5.1-4.2-4.8-20.7-9.6-20Z",
    fill: "#ffb88c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M686.7,728.8c-.5,0-.9-.3-.9-.8-.1-.5.2-.9.7-1c0,0,2.6-.4,4.1-1.1.5-.1,1,.1,1.2.5.2.5,0,1.1-.5,1.2-1.7.7-4.4,1.2-4.5,1.2q-.1,0-.1,0Z",
    fill: "#e4807c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M690,737.2c-.5,0-.9-.3-.9-.8s.4-1,.9-1c0,0,2.4-.1,4.3-.8.4-.2,1,0,1.2.5.1.5-.1,1-.6,1.2-2.2.8-4.7.9-4.8.9q0,0-.1,0Z",
    fill: "#e4807c"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M813.6,671q-.1,0-.2,0c-.5-.1-.8-.6-.8-1.1.6-3.7-.4-7.6-2.5-10.7-.3-.4-.2-1,.2-1.3s1-.2,1.3.3c2.4,3.4,3.5,7.8,2.9,12-.1.4-.5.8-.9.8Z",
    fill: "#e4807c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M683,717.5q-.1,0-.1,0c-.6,0-1.1-.6-1.1-1.2.4-6.7,6.1-12.6,12.8-13.2.6,0,1.2.4,1.3,1.1c0,.6-.5,1.2-1.1,1.3-5.6.5-10.3,5.4-10.6,10.9-.1.7-.6,1.1-1.2,1.1Z",
    fill: "#bc4d4d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M676.5,719.3c-.5,0-1-.3-1.2-.9-1-4.2.3-8.8,3.3-11.8.5-.5,1.2-.5,1.7,0c.5.4.5,1.2,0,1.6-2.5,2.5-3.6,6.3-2.7,9.6.2.7-.2,1.3-.8,1.5q-.2,0-.3,0Z",
    fill: "#bc4d4d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M671.6,514.1q0,0,.1-.1q0-.1.1-.1.4-.6.9-1.1t1-1t1-.9q.6-.5,1.1-.9q1.1-.9,2.4-1.4t2.7-.7c2.1-.2,3.7.6,4.8,2c1.1,1.3,1.7,3.2,1.7,5.1.2,3.3-1.9,7.2-5,9.7-3,2.5-6.9,3.7-10.3,1.7q-.7-.3-1.2-.9t-.9-1.3c-.3-.7-.5-1.5-.6-2.4-.1-.8-.1-1.7,0-2.5q.2-1.4.7-2.7.6-1.3,1.5-2.5Z",
    fill: "url(#e7VyGK2MPtc136-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.1,513.1q.2.9.3,1.9t.1,2c0,1.9-.2,3.7-.5,5.6-.3,1.8-.7,3.7-1.1,5.4-.6,2.5-.4,4.9.1,7.1.6,2.3,1.6,4.4,2.7,6.6q1.2,2.7,2.6,5.2t3.1,4.8q.8,1.2,1.7,2.4.9,1.1,1.8,2.2c.5.6.9,1.2,1.4,1.7.5.6,1,1.1,1.7,1.5q.3.2.7.4t.8.4q.5.1.9.3.5.1.9.2q0,0,.1,0q0,.1.1.1h.3l.3.1q.7.1,1.5.2.7,0,1.5.1c.5,0,1.2,0,1.8,0s1.1.1,1.1.1l.1.2v.3q.1.2,0,.4q0,.2,0,.4.1.9,0,1.7q0,.9,0,1.8-.1,1.1-.2,2.1t-.3,2.1c0,.3-.3,1.7-.6,3.4s-.8,3.5-1.2,4.7c-.4,1.1-.9,2.2-1.3,2.9s-.7,1.2-.7,1.2.2.2.5.5c.2.3.6.6.8.8c2,1.7,4.4,2.9,7,3.8c2.5.9,5.2,1.5,7.7,2c2.9.5,5.7.7,8.6.6c2.8-.1,5.5-.6,8.4-1.4q2.2-.7,4.2-1.7t3.8-2.3q1-.7,1.9-1.4.9-.8,1.7-1.6c.4-.4,1.1-1.1,1.6-1.9.6-.7,1.1-1.5,1.2-2.1-.4-.4-.8-.8-1.1-1.1-.4-.4-.7-.7-1-1.3q-1.8-3.6-3.3-7.3-1.5-3.8-2.5-7.7-.2-.7-.4-1.4-.2-.8-.3-1.5c-.7-3.1-.9-6.1-1-9.2s0-6.2.1-9.3q.3-4.7.6-9.5.4-4.7.9-9.5q0-.5,0-1q.1-.5.1-1q.3-3.3.7-6.6.3-3.3.8-6.6c.3-2.2.7-4.3,1.1-6.4.3-2.2.6-4.3.7-6.5v-.4-.4c0-1.2-.1-2.1-.5-2.9s-1-1.5-1.8-2.4q-.3-.4-.6-.7-.4-.3-.7-.6-.8-.7-1.7-1.4-.9-.6-1.9-1.2-.7-.3-1.3-.6-.7-.3-1.4-.6-.4-.1-.7-.2-.3-.2-.7-.3-.3-.1-.5-.1-.3-.1-.6-.2-.4-.1-.8-.2-.5-.1-1-.2c-2.3-.3-4.5-.8-6.8-1.2-2.3-.3-4.6-.6-6.9-.6q-4.5-.1-9,0-4.6.1-9.1.3-.8,0-1.7,0t-1.9,0q-.4,0-.7,0t-.7,0q-.2,0-.5.1-.3,0-.6,0-.2,0-.4.1-.3,0-.5,0-.5.1-.9.2-.5.1-.9.2-1.1.3-2,.8-.9.6-1.5,1.4-.3.4-.6.8t-.5.9c-1.4,2.2-2.6,4.8-3.4,7.5-.9,2.6-1.4,5.4-1.7,7.9q-.2,1.6-.1,3.3.1,1.6.4,3.3c.2,1.4.5,2.8.8,4.2.4,1.4.7,2.8.9,4.3Z",
    fill: "#ffb88c"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.4,482.2c.5.3,1.2.7,1.8,1s1.1.5,1.4.7q1.6.8,3.3,1.5q1.7.6,3.4,1.1q3.2,1,6.4,1.6t6.4.9c2.2.2,4.3.3,6.4.3c2.1.1,4.2,0,6.3,0c.8,0,1.8,0,2.8,0c1,.1,1.9.2,2.6.5c1.1.4,1.7,1.2,2.2,2.2.4.9.7,1.9,1.1,2.8.7,2.2,1.1,4.4,1.4,6.6.2,2.3.2,4.6.4,6.8.1,2.5.1,5.1.1,7.6s-.2,5-.5,7.4c-.7,5.5-1.7,10.8-3.5,15.8-1.9,4.9-4.6,9.4-9,13.3q-.8.7-1.7,1.3-.8.7-1.8,1.3c-1.9,1.2-3.9,2.2-6,3s-4.3,1.4-6.5,1.9c-.8.1-1.9.1-2.9.1s-1.7,0-1.7,0q.2.1.6.2.4.2,1.1.3q0,0,.1,0q0,.1.1.1h.3l.3.1q.7.1,1.5.2.7,0,1.5,0c.5.1,1.2.1,1.8.1s1.1.1,1.1.1l.1.1.1.2q.2,0,.4,0q.1.1.3.1.4.1.7.2.4.2.7.3c.1,0,.3,0,.5.1s.3.2.3.3c.1.6,1.1.9,2.1,1.2c1.1.3,2.1.6,2.1,1.2c0,.7,1.1.7,2.3.8c1.1,0,2.2,0,2.1.6c2.6,1.1,3.9,1.9,5.3,2.4c1.3.6,2.7.9,5.5,1.1c1.8.1,3.7.5,5.6.7s3.7.3,5.5,0q.7-.2,1.3-.4.7-.2,1.3-.5c.2-.1.6-.2.9-.3.3-.2.6-.3.7-.6.1-.2-.1-.7-.3-1.1-.2-.5-.4-.9-.5-1.2q-.5-1.2-.9-2.5-.4-1.2-.7-2.5-.7-2.6-1.2-5.2-.4-2.6-.6-5.3q0-1,0-2-.1-.9,0-1.9q0-3.5.1-7t.3-7c.1-2.2.3-4.4.5-6.5.3-2.2.5-4.4.6-6.6q0-.5.1-1q0-.5.1-1q.3-3.3.6-6.6t.8-6.6c.3-2.2.7-4.3,1.1-6.5.4-2.1.7-4.3.8-6.5v-.4-.3c0-1.2-.2-2.1-.6-2.9s-1-1.5-1.8-2.5q-.3-.3-.6-.6t-.6-.6q-.8-.7-1.7-1.4-.9-.6-1.9-1.2-.7-.3-1.3-.6-.7-.3-1.4-.6-.4-.1-.7-.3-.3-.1-.7-.2-.3-.1-.5-.1-.3-.1-.5-.2-.4-.1-.9-.2t-1.1-.2c-2.2-.4-4.5-.8-6.8-1.2-2.2-.4-4.5-.7-6.8-.7q-4.6,0-9.1.1-4.5,0-9.1.2-.7.1-1.6.1t-1.9,0q-.3,0-.7,0-.3,0-.7,0-.2,0-.5.1-.3,0-.6,0-.2,0-.4,0-.3.1-.5.1-.5.1-.9.2-.5.1-.9.2-1.1.3-2,.8-.9.6-1.5,1.4-.3.4-.6.8-.2.4-.5.9Z",
    fill: "url(#e7VyGK2MPtc139-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642.2,507c-.5,1.5-1,3.2-1.3,4.8-.2,1.7-.3,3.4,0,5q.2.6.4,1.2t.6,1.2c.5.7,1.3,1.1,2.1,1.4s1.7.6,2.5.9q.7.3,1.5.6t1.5.5c2.9.6,5.7-.3,8-1.9s4-4,4.8-6.4c.3-1.2.7-3.3.5-5.2-.2-2-1-3.6-3.1-3.9q-.6,0-1.2-.1-.6-.2-1.3-.2-1.2,0-2.4.1-1.2.2-2.4.5c-.9.2-1.9.5-2.8.8s-1.8.6-2.8.8q-.6.1-1.1.1t-1-.2c-.3-.2-.6-.5-1-.7-.3-.2-.7-.3-1-.1-.1,0-.3.2-.4.4c0,.1-.1.3-.1.4Z",
    fill: "url(#e7VyGK2MPtc141-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M641.1,517.8c0,.8.3,1.3.7,1.7.5.5,1,.9,1.5,1.2q.1.1.1.1.1,0,.1,0t.1.1q.2.1.4.2c.6.3,1.1.5,1.7.6.5.2,1.1.3,1.7.4q.2,0,.3,0t.2,0q.6,0,1.2.1.6,0,1.2,0q.5,0,1-.1.5,0,.9-.1.9-.2,1.7-.6.7-.5,1.3-1.2q0,0,0,0t.1,0c.6-.8,1.2-1.7,1.6-2.7s.7-2,.8-3q.1-.2.1-.4q0-.3,0-.5c0-.5,0-1.1-.2-1.6s-.5-.9-1.1-1.2q-1.1-.4-2.2-.6t-2.3-.2c-1.8-.1-3.6-.1-5.3.4-1.6.6-3.1,1.5-4.1,3.1q-.3.6-.7,1.2-.3.6-.5,1.3-.1.3-.2.7-.1.3-.1.7q0,.1,0,.2t0,.2Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.6,504.1q0,0,0,0t0,.1c.2,1.4.5,2.8.9,4.2.3,1.4.6,2.8.8,4.3q.2.9.3,1.9t.4,1.9c0,0,.1,0,.3,0s.3-.1.3,0c0,0,0,.1.1.2c0,.1,0,.2,0,.2.7,1.1,1.4,2,2.2,2.7s1.7,1.1,3.1,1.2c.7.1,1.5.1,2.2-.1.7-.3,1.4-.6,1.9-1.2q.6-.9.9-1.9.3-1.1.3-2.1c0-1.6-.2-3.4-.7-5-.5-1.7-1.2-3.3-2.2-4.5q-.1-.1-.3-.2t-.4-.2q-1.1-.5-2.3-.9t-2.4-.7c-.8-.2-1.8-.4-2.7-.5-1-.1-2,.1-2.7.6Z",
    fill: "url(#e7VyGK2MPtc144-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M613.7,513.4q0,.2,0,.5q0,.2,0,.5q0,.2,0,.4t.1.4q0,.6.1,1.3.2.7.4,1.3q0,.1.1.1q0,.1,0,.2c.3.5.6.9,1.1,1.2.4.3.9.6,1.5.8q.1.1.1.1.1,0,.2.1.3.1.7.2.3.2.6.3c.9.2,1.8.4,2.7.4.8,0,1.7-.2,2.3-.7q.3-.2.5-.4.2-.3.3-.6q0-.1.1-.1q0,0,0-.1.3-.6.4-1.4q0-.7-.1-1.4-.2-1-.6-2-.5-.9-1-1.7c-.8-1.1-1.9-1.9-3.1-2.5-1.3-.5-2.7-.8-4-.9-.4,0-.9,0-1.3.1-.3.2-.6.4-.8,1q-.1.3-.1.7-.1.4-.2.7q0,.4,0,.7q0,.4,0,.8Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.3,532.9q-.8.3-1.7.4-1,.2-1.8.2-.9,0-1.7-.1-.9-.1-1.7-.3-.4-.1-.8-.2t-.7-.3c-.2-.1-.3-.1-.3-.1-.1,0-.2,0-.2.2q0,.1,0,.3q0,.1,0,.2-.1-.1-.1-.3q0-.1.1-.3c0-.3.2-.6.3-.8.2-.2.4-.3.5-.2.5.2,1,.4,1.5.5.4.1.8.2,1,.2q1.1.3,2.2.3q1.1.1,2.3-.1c.4,0,1.1-.1,1.8-.3.7-.1,1.5-.4,2-.7q-.2.2-.5.4t-.5.3q-.4.2-.8.4-.5.1-.9.3Z",
    fill: "#ffe5d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.4,532.7c0-.2.1-.2.2-.2c0,0,.1,0,.3.1q.3.2.7.3t.8.2q.8.2,1.7.3.8.1,1.7.1.8,0,1.8-.2.9-.1,1.7-.4.4-.2.9-.3.4-.2.8-.4.2-.1.5-.3t.5-.4q.1-.1.2-.1.1-.1.1-.2.3.2.5.3.2.2.4.3.5.4,1,.7.6.4,1,.8t.4.8-.1.8q-.1.3-.2.5t-.2.5q-.1.2-.2.4-.1.3-.4.3-.1.1-.2.1t-.3-.1q-.2,0-.3,0-.2-.1-.4-.1t-.4,0q-.2-.1-.4-.1c-.6-.1-1.3,0-1.9.1s-1.3.3-1.9.5q-.8.2-1.7.3t-1.8.1q-.9.1-1.7-.2-.9-.2-1.6-.8c-.4-.4-.7-.8-1-1.3s-.5-1.1-.5-1.7q0,0,0-.1q0,0,0-.1t0-.2q0-.2,0-.3Z",
    fill: "url(#e7VyGK2MPtc147-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.2,561c0-.1.1.3.1.6s0,.6,0,.5c0,0,.3.2.6.5.3.2.6.5.7.6q.6.5,1.3.9.6.4,1.3.7q1.2.8,2.5,1.6q1.3.7,2.7,1.4q2.6,1.3,5.3,2.4q2.8,1.1,5.5,2.1q4.5,1.6,8.9,2.9q4.5,1.3,9.1,2.3.6.1,1.1.2.6.1,1.1.2c.3,0,.9,0,1.6-.1.6-.1,1.2-.2,1.4-.3c0,0-.3-.4-.6-1-.3-.5-.7-1.1-.9-1.4q-1.1-1.9-2-3.9t-1.7-4q-1.7-4.2-2.7-8.6-.9-4.3-1.2-8.8q0-.1-.1-.2q0-.1,0-.2-.1-1.4-.1-2.8-.1-1.5-.1-2.9q0-3,.1-5.9.2-2.9.4-5.8q0-.8.1-1.6t.1-1.7q.2-2.2.4-4.4.1-2.2.3-4.4q0,0,0-.1q0,0,0-.1c-.3-.5-.6-1.2-.9-1.7-.3-.6-.7-1.1-1-1.5q-.9,2.9-1.5,6-.6,3-1,6.1-.4,2.8-.9,5.7-.6,2.8-1,5.6c-.2,1.5-.5,3-1,4.4s-1.2,2.7-2.2,3.8q-.7.6-1.5,1.2t-1.6,1.2q-2.2,1.5-4.5,2.9t-4.7,2.7q-1.6.8-3.2,1.6-1.7.8-3.4,1.4-.9.3-1.7.6-.9.3-1.8.5c-.4.1-.9.3-1.5.4s-1.2.2-1.8.4Z",
    fill: "url(#e7VyGK2MPtc148-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.3,534.2q.2.6.6,1.2t.9,1q.3.2.6.5.4.2.8.3-.2-.2-.4-.2-.1-.1-.2-.2-.2-.2-.5-.4-.2-.3-.4-.5-.3-.3-.5-.5-.2-.3-.3-.6-.3-.4-.4-.9t-.1-.9q0-.2.1-.4q0-.2.1-.4.2-.2.5-.5.2-.2.5-.4.2-.2.3-.4.2-.2.4-.4c.3-.3.6-.8.8-1.3.3-.5.5-1,.7-1.3.2-.6.4-1,.5-1.4.2-.4.3-.9.5-1.4q.7-2.2.8-4.5.2-2.3-.2-4.6-.3-1.6-.8-3.1-.6-1.5-1.4-2.9-.1-.2-.3-.5t-.3-.5q-.2-.3-.4-.4-.1-.2-.3-.4q0,0-.1,0q0,0-.1,0q0,.1,0,.1t.1.1q.7,1,1.3,2.1.6,1.2,1,2.4.2.6.4,1.3.2.6.3,1.3c.3,1.3.4,2.7.4,4.1s-.2,2.8-.5,4.1c-.1.5-.3,1.2-.5,1.8s-.4,1.3-.6,1.8c-.3.7-.6,1.3-.9,1.8-.3.6-.6,1.2-1.1,1.7q-.3.3-.5.5t-.4.4q-.2.1-.3.3t-.2.4q-.2.4-.1.9q0,.5.2.9Z",
    fill: "url(#e7VyGK2MPtc149-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.5,473.5q1.5-.7,3-1.2q1.5-.4,3.1-.8c1.2-.2,2.3-.3,3.5-.3c1.1,0,2.2.1,3.5.1-1.7-1.8-3.7-3.4-5.9-4.7s-4.5-2.4-6.9-3c.4-1.2,1.6-2.3,3-3.3c1.4-.9,2.9-1.7,4-2.2c3.3-1.5,6.7-2.4,10.2-2.9c3.4-.4,7-.3,10.6.2q3,.4,5.8,1.3t5.5,2.1c1.1.5,2.1,1.1,3.1,1.7s2,1.3,3,1.9c1,.5,1.8,1.1,2.7,1.8.8.6,1.6,1.3,2.5,1.9.8-1,1.9-1.8,3.2-2.3c1.3-.6,2.7-.9,3.9-1q1.5-.1,3,.1t2.9.7c.6.2,1.6.5,2.5.9c1,.5,1.8,1.1,2,1.8-2.2-.4-4.5-.1-6.5.8s-3.6,2.5-4.4,4.7c1.6-.1,3.3.1,4.9.5s3.2,1,4.6,1.8q.9.4,1.8,1q.8.6,1.6,1.2c.4.4.9.8,1.4,1.3s.8,1.1,1,1.6c-1.3-.3-2.6,0-3.7.6-1.1.7-2,1.7-2.7,2.8-.6,1-1.1,2-1.4,3.1-.4,1.1-.6,2.2-.9,3.3q-.4,1.7-.9,3.4-.5,1.8-.9,3.5-.7,3.1-1.3,6.3-.7,3.1-1.2,6.3-.4,2.2-.8,4.5t-.7,4.5c0,.8-.1,1.5-.1,2.3-.1.7-.2,1.4-.3,2.2-.1,1-.1,1.8-.2,2.6c0,.8-.1,1.6-.2,2.7.1-.2-.2-.4-.4-.6-.3-.1-.6-.3-.7-.3q-.3-.2-.6-.3-.2-.2-.5-.3c-.1,0-.4-.1-.6-.2-.3-.1-.5-.2-.5-.3q.1-.9.3-1.8t.3-1.8.2-1.8.2-1.8q0-.4.1-.7q0-.4.1-.8q0-.3,0-.6.1-.4.1-.7.5-4.7.6-9.5.1-4.7-.1-9.5q0-.7,0-1.4-.1-.7-.2-1.4q0-.1-.1-.2q0-.1-.1-.2q0,0-.1-.1-.1,0-.1-.1-.5-.2-1-.4-.4-.2-.9-.4c-.2-.1-.6-.2-.9-.3s-.6-.2-.7-.4q-.1,0-.1-.1t0-.1q-.1-1,0-1.9q0-1,.1-1.9q0-.6,0-1.1q0-.6,0-1.1.1-.4.1-.7t0-.7q0,0,0-.1t0-.2q0-.3.1-.5q0-.3,0-.6c-1.5.6-3.2.9-4.9,1.2-1.6.3-3.4.4-4.9.5-3.6.2-7.2.6-10.8.9s-7.2.4-10.8,0q-2.6-.3-5.2-.8-2.7-.4-5.3-1c-1.6-.4-3.1-.9-4.5-1.6-1.5-.6-2.9-1.2-4.5-1.8-1.4-.2-3.2.3-4.9,1-1.7.8-3.4,1.7-4.5,2.4.9-2,2-3.9,3.4-5.6c1.3-1.7,3-3.1,5-4.1Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624,504.3c-.5.3-1.1.3-1.7,0-.6-.2-1.2-.5-1.6-.8q-.9-.5-1.8-1.1-.9-.5-1.9-.9-1.2-.5-2.5-.8t-2.6-.4q-.3,0-.7,0-.3.1-.5.3c-.2.2-.3.5-.4.7c0,.3-.1.6-.1.9q0,.4,0,.9t.2.9q.1.4.3.7.3.3.5.5.1.1.2.2t.2.1q.2.2.5.3t.5.2q.4.1.8.2.3.1.7.2t.8.2q.4.2.8.3q1.5.5,2.9,1q1.5.6,2.9,1c.4.1.9.2,1.4.3.5,0,.9-.1,1.3-.5q.1-.2.2-.4.1-.3.2-.5c.1-.6.1-1.2,0-1.8s-.4-1.2-.6-1.7Z",
    fill: "url(#e7VyGK2MPtc151-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.1,504.3c0,.2.4.3.9.3.4.1.9.1,1,.1.4,0,1.1-.1,1.7-.2.7,0,1.4-.1,1.8-.2.8-.2,1.5-.4,2.1-.6q1-.2,1.9-.3c1.5-.2,2.7-.4,3.9-.6c1.2-.1,2.5-.2,4-.3q.6,0,1.2-.1.5,0,1.1.2.4.2.8.4t.8.4q.5.3.8.7.4.4.8.8c.5.6.9,1.3,1.2,2c.3.8.4,1.5.4,2.3c0,.3-.3.2-.6,0s-.6-.5-.6-.5c-.8-.4-1.6-.7-2.5-.8s-1.8-.1-2.6-.2q-1.5,0-3,.1t-3,.3c-1,.1-1.8.2-2.6.4-.8.1-1.5.2-2.6.4-.6.1-1.3.2-1.9.3-.7.1-1.3.2-1.8.2q-.6-.1-1.1-.3t-1-.6q-.4-.2-.6-.6t-.3-.8c-.1-.4-.2-.9-.3-1.4s0-1,.1-1.4Z",
    fill: "url(#e7VyGK2MPtc152-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675,524.1c.4.1.9.1,1.4.1.5-.1,1-.3,1.4-.4q.7-.2,1.3-.5.6-.4,1.1-.9c.6-.5,1.1-1.2,1.5-1.9.4-.8.6-1.7.7-2.6q0-.5-.1-1.1-.2-.5-.5-1c-.2-.5-.6-.8-1.1-1.1-.4-.4-.9-.6-1.4-.7q-1.4-.4-2.5,0-1.2.3-2.2,1.4-.3.3-.6.7t-.6.8q0,0-.1.1q0,.1-.1.2t-.2.3q0,.1-.1.3c.3-.4.8-.8,1.3-1.1.5-.2,1-.4,1.6-.3q.4,0,.7.2.4.2.7.6c.7.7.8,1.6.8,2.4-.1.9-.5,1.8-.9,2.5-.3.5-.6.8-.9,1.1s-.7.6-1.2.9Z",
    fill: "#910f2e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M636.1,532.4q.2.1.4.2t.4.3q.2.1.3.2.2.1.3.2.4.4.4.8q0,.5-.2.9-.1.4-.4.8-.2.4-.5.7c0,0,.1-.2.2-.5.2-.3.3-.7.4-1c0-.2.1-.4.1-.6s0-.4,0-.6q-.1-.1-.3-.3-.1-.1-.3-.2-.3-.2-.7-.5t-.8-.5q-.1-.1-.3-.3-.2-.1-.3-.2c-.1-.1-.3-.3-.4-.4s-.2-.2-.1-.2q.4.3.9.6.4.3.9.6Z",
    fill: "#cc5e48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M629.8,537.3c0-.1.1-.2.2-.3.2-.2.4-.3.5-.3q.2-.2.5-.3t.6-.2c.4-.2.8-.3,1.2-.4s.9-.1,1.3,0q.3.1.4.2.1.2-.1.5-.1.2-.3.3-.3.1-.5.2-.5.1-.9.1-.5,0-1,0t-.9.1q-.5,0-1,.1Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.1,518.3v.1.1c0,.7.3,1.2.7,1.7.5.4,1,.8,1.5,1.2q.1,0,.1,0q.1.1.1.1t.1.1q.2,0,.4.1c.6.3,1.1.5,1.7.7.5.1,1.1.2,1.7.3q.2,0,.3,0q.1.1.2.1.5,0,.9,0q.5,0,.9,0q.1,0,.2,0t.2,0h.1.1q.5,0,1,0q.5-.1.9-.2.4,0,.7-.2.4-.1.7-.2.7-.4,1.2-1q.6-.5,1-1.2.2-.3.4-.6.2-.4.3-.7.2-.4.4-.8.2-.3.3-.7.2-.5.3-1.1.2-.5.2-1q.1-.2.1-.4t0-.4c0-.6,0-1.1-.2-1.6s-.5-.9-1.1-1.2q-1.1-.5-2.2-.7t-2.3-.2c-1.8-.1-3.6,0-5.3.5-1.6.5-3.1,1.4-4.1,3.1q-.3.5-.7,1.2-.3.6-.5,1.2-.1.3-.2.7-.1.3-.1.7q0,.1,0,.1q0,.1,0,.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.1,518.3q1.5-.5,3-.9t3.1-.5q.8-.1,1.7-.2t1.8-.1q.3,0,.6,0q.4,0,.7,0q1.3.1,2.6.3q1.3.1,2.6.3.2-.5.3-1.1.2-.5.2-1q.1-.2.1-.4t0-.4c0-.6,0-1.1-.2-1.6s-.5-.9-1.1-1.2q-1.1-.5-2.2-.7t-2.3-.2c-1.8-.1-3.6,0-5.3.5-1.6.5-3.1,1.4-4.1,3.1q-.3.5-.7,1.2-.3.6-.5,1.2-.1.3-.2.7-.1.3-.1.7q0,.1,0,.1q0,.1,0,.2Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.7,514q0,.1,0,.3q0,.1,0,.2q0,.3.1.7q0,.4,0,.8l.1.1v.1.1c0,0,0,.2.1.4c0,.2,0,.4,0,.5q.1.2.1.4q0,.1.1.3.1.4.2.7.2.4.4.7.4.6.9.9.6.3,1.2.6.1,0,.2.1.1,0,.2.1.1,0,.2.1.1,0,.2,0q0,0,.1.1q0,0,.1,0q.1.1.3.1.2.1.4.2q0,0,0,0t0,0q.1,0,.1,0q.1,0,.1,0q.2.1.4.1.1,0,.3.1.2,0,.3,0q.2.1.3.1t.2,0t.1,0q.1,0,.2,0q.1.1.2.1.8,0,1.5-.1.7-.2,1.3-.6.2-.2.3-.3.2-.2.3-.3q0,0,0-.1q0,0,0-.1.1,0,.1-.1q0,0,.1-.1q0,0,0-.1q0,0,0-.1c.1,0,.1-.1.1-.2s0-.2,0-.2q.3-.6.3-1.2.1-.6,0-1.2t-.3-1.1q-.2-.6-.5-1.1q0-.2-.1-.3-.1-.2-.2-.3q0-.1,0-.2-.1,0-.1-.1-.1-.1-.1-.2-.1-.1-.2-.2q0-.1,0-.1-.1-.1-.1-.2-.1,0-.1,0t0-.1q0,0-.1-.1q0,0,0,0-.1-.1-.2-.2t-.1-.2c-.8-.9-1.9-1.5-3-2-1.2-.4-2.4-.6-3.6-.7-.4,0-.9,0-1.3.1-.3.2-.6.4-.8.9q0,.2,0,.3-.1.1-.1.2q0,.2-.1.5q0,.3-.1.5q0,.4,0,.7q0,.4,0,.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.7,514.1q0,.1,0,.2t0,.2q0,.4.1.7q0,.4,0,.8l.1.2v.2q.4,0,.9.1.4.1.8.1q1.1.2,2.2.5q1.1.2,2.1.5h.1q.5.2.9.3.5.2,1,.4.7.3,1.4.6.7.4,1.3.9.2-.7.3-1.3q0-.6-.1-1.3-.2-.8-.5-1.6t-.7-1.5q-1.4-.8-2.9-1.4t-3.1-.8q-.9-.1-1.8-.2-1-.2-1.9-.1q0,.3-.1.5q0,.3-.1.5q0,.4,0,.8q0,.3,0,.7Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.6,454.7c-1.5.4-2.6.7-3.5,1.2-1,.6-1.8,1.2-2.7,2.1-.9.8-1.6,1.8-2.2,2.9s-1,2.3-1,3.5c.1-.5.5-1.1.9-1.6.3-.6.8-1.1,1.1-1.5q.5-.8,1.1-1.5.6-.6,1.2-1.3c.7-.9,1.5-1.6,2.3-2.2.9-.6,1.8-1.1,2.8-1.6Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.6,511.7c0-1.7-1.1-2.5-2.4-2.8s-2.9,0-4,.8q-.4.3-.9.6-.4.4-.7.8c-.2.3-.4.7-.4,1s.1.6.5.8c.3.1.7.1,1,.1.4-.1.8-.1,1.1-.1q.6,0,1.2.1t1.2.3q.6.1,1.1.1t1.1-.2c.3-.2.6-.4.8-.7.3-.2.5-.5.4-.8Z",
    fill: "url(#e7VyGK2MPtc162-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.9,517.8c.3-.4.8-.8,1.3-1.1.5-.2,1-.4,1.6-.3.4-.2.9,0,1.3.3s.8.7,1.1,1c.2.4.4.9.5,1.5.2.5.2,1,.1,1.5-.1.4-.2.9-.4,1.4-.2.6-.5,1-.9,1.2.7-.2,1.4-.6,2-1.1s1.1-1.2,1.5-1.8q.4-.8.5-1.6.2-.9-.1-1.8c-.1-.7-.5-1.3-.9-1.7-.5-.4-1.2-.7-1.9-.7-1-.2-2,0-2.9.4-.9.5-1.6,1.1-2.3,1.9q0,0-.1.1q0,.1-.1.2t-.2.3q0,.1-.1.3Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M654.7,461.7q0,.2,0,.4-.1.2-.3.5-.4.4-.8.8-.4.5-.9.8-1,.5-2,.9-1.1.4-2.1.7-.5.1-1,.2t-1,.1q-.5-.1-.8-.3-.4-.2-.8-.4-1.8-.8-3.6-1.6-1.8-.7-3.7-1.3-1.8-.6-3.8-.8-1.9-.2-3.9.1c2,0,4,.4,5.9,1.1c2,.6,3.8,1.6,5.4,2.8q.2.1.3.3.2.2.3.4c.2.7-.6,1-1.5,1.1s-2,0-2.3-.1q-1.2-.2-2.3-.6-1.1-.5-2.2-.9c-2.1-.8-4.2-1.5-6.4-2-2.1-.6-4.3-1-6.6-1.2.2,0,.4,0,.6-.1s.4-.2.6-.3q.3-.1.7-.2t.7-.2q.8-.2,1.5-.3.7-.2,1.5-.3q2.4-.4,4.9-.7q2.5-.2,5-.3-1.6-.3-3.3-.4-1.6-.2-3.2-.2-.9.1-1.7.1t-1.7.1q-.2,0-.4,0t-.4,0c-.1,0-.2.1-.4.1-.1,0-.3,0-.3,0-.2-.1-.2-.2-.1-.3s.2-.2.3-.2q.4-.2.8-.4.3-.1.7-.3.7-.3,1.5-.5t1.6-.4q.9-.2,1.8-.3t1.8-.2c1.9-.3,3.7-.4,5.5-.4c1.9,0,3.7.1,5.6.5q2.6.5,5,1.4q2.5.9,4.8,2.2.3.2.4.3.2.2.3.3Z",
    fill: "url(#e7VyGK2MPtc165-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M643.5,521.5c0,0,.6.3,1.4.7.8.3,1.9.7,2.9.8.6,0,1.4,0,2.2,0s1.6-.1,2.3-.2q.9-.2,1.5-.7.7-.4,1.3-1.1c-.6.2-1.2.4-1.8.5-.5.2-1,.2-1.2.3q-1.4.2-2.8.2t-2.8-.1c-.4,0-1.2-.1-1.8-.2s-1.1-.2-1.2-.2Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622,521.9q-1,0-2-.2-.9-.2-1.9-.5c-.6-.2-1.3-.5-1.9-.8-.6-.4-1.2-.8-1.6-1.4q.3.6.6,1t.6.8q.4.4,1,.6.5.2,1,.3.6.2,1.2.3t1.2.1q.5-.1.9-.1.5-.1.9-.1Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.3,516.7c0,1.4.5,2.7,1.5,3.7.9.9,2.2,1.5,3.6,1.5c1.5,0,2.8-.6,3.7-1.5.9-1,1.5-2.3,1.5-3.7s-.6-2.7-1.5-3.7c-.9-.9-2.2-1.5-3.7-1.5-1.4,0-2.7.6-3.6,1.5-1,1-1.5,2.3-1.5,3.7Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.6,516.7c0,1.3.6,2.5,1.4,3.4.9.9,2.1,1.4,3.4,1.4c1.4,0,2.6-.5,3.4-1.4.9-.9,1.4-2.1,1.4-3.4s-.5-2.5-1.4-3.4c-.8-.9-2-1.4-3.4-1.4-1.3,0-2.5.5-3.4,1.4-.8.9-1.4,2.1-1.4,3.4Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.6,516.7q0,0,0,.1q0,0,0,.1c.1,0,.8-.1,1.7-.1.8-.1,1.8-.2,2.4-.2q.3,0,.6,0q.4,0,.7,0q1.1,0,2.1.2q1.1.1,2.1.3q0-.1.1-.3q0-.1,0-.1c0-1.4-.6-2.6-1.5-3.4-.8-.9-2-1.4-3.4-1.4-1.3,0-2.5.5-3.4,1.4-.8.9-1.4,2.1-1.4,3.4Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.4,516.7c0,.8.3,1.6.9,2.1.5.6,1.3.9,2.1.9.9,0,1.6-.3,2.2-.9.5-.5.9-1.3.9-2.1s-.4-1.6-.9-2.2c-.6-.5-1.3-.8-2.2-.8-.8,0-1.6.3-2.1.8-.6.6-.9,1.4-.9,2.2Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.4,516.5c-.2.6-.2,1-.3,1.2c0,.3,0,.4,0,.4.1-.2.7-.8,1.3-1.4.6-.7,1.3-1.3,1.6-1.4.3-.2.6-.4.9-.6.3-.3.7-.5,1-.5q1-.2,1.9-.4q1-.1,2-.1q1.1,0,2.1.1q1.1.1,2.2.2.9.1,1.8.2q1,.1,1.9.1c0-.6,0-1.1-.2-1.6s-.5-.9-1.1-1.2q-1.1-.5-2.2-.7t-2.3-.2c-1.8-.1-3.6,0-5.3.5-1.6.5-3.1,1.4-4.1,3.1q-.3.5-.7,1.1-.3.6-.5,1.2Z",
    fill: "url(#e7VyGK2MPtc172-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.1,518.1c0,0,.2-.2.3-.4.2-.1.4-.3.5-.4q.5-.5.8-.7.4-.2.6-.3c.2-.2.4-.3.6-.4s.4-.2.7-.3q1-.4,1.9-.5q1-.2,2-.3.7,0,1.4-.1.7,0,1.4.1.9,0,1.7.1t1.6.1q.7.1,1.5.1t1.6-.1c.6,0,1-.3,1.2-.8.3-.4.4-.9.6-1.3-.2.1-.4.2-.7.2-.2,0-.5,0-.7,0q-.5.1-1,.1-.5-.1-1-.1-1.3,0-2.6,0t-2.6.1c-1.2.1-2.6.2-3.9.5s-2.5.8-3.6,1.6q-.3.3-.7.6-.3.3-.6.7c-.1.1-.3.5-.6.8-.2.3-.4.7-.4.7Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.7,517.2c0,1.2.5,2.3,1.3,3.2.9.8,2,1.3,3.3,1.3q.8,0,1.6-.3.7-.3,1.3-.8q0,0,.2-.3.1-.2.2-.6c0-.3.1-.7.2-1.1c0-.5,0-1,0-1.4q-.1-.6-.3-1.1-.2-.6-.5-1.1q0-.2-.1-.3-.1-.2-.2-.3q0-.1,0-.2-.1,0-.1-.1-.1-.1-.1-.2-.1-.1-.2-.2q0-.1,0-.1-.1-.1-.1-.2-.1,0-.1,0t0-.1q0,0-.1-.1q0,0,0,0-.1-.1-.2-.2t-.1-.2q-.4-.1-.7-.1-.4-.1-.7-.1c-1.3,0-2.4.5-3.3,1.3-.8.9-1.3,2-1.3,3.3Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617,517.2c0,1.1.5,2.2,1.3,2.9.7.8,1.8,1.3,3,1.3q1,0,1.9-.5.8-.4,1.4-1.2c.1-.3.2-.7.2-1.1c0-.5,0-1,0-1.4q-.1-.6-.3-1.1-.2-.6-.5-1.1q0-.2-.1-.3-.1-.2-.2-.3q0-.1,0-.2-.1,0-.1-.1-.1-.1-.1-.2-.1-.1-.2-.2q0-.1,0-.1-.1-.1-.1-.2-.1,0-.1,0t0-.1q-.4-.2-.9-.3-.4-.1-.9-.1c-1.2,0-2.3.5-3,1.3-.8.7-1.3,1.8-1.3,3Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617,516.9q.7.1,1.5.3.7.2,1.4.4.6.1,1,.3.5.2,1,.4.7.3,1.3.7.7.4,1.3.9v-.1h.1q.2-.7.3-1.3q0-.7-.1-1.3-.1-.3-.2-.6q0-.2-.1-.5t-.2-.5q-.1-.3-.3-.6q0-.1-.1-.3-.1-.1-.1-.3q0,0-.1,0q0,0,0,0q0-.1,0-.2-.1,0-.1-.1-.6-.4-1.2-.7-.6-.2-1.2-.5c-1.1,0-2.1.5-2.9,1.2s-1.2,1.7-1.3,2.8Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.6,517.1c0,.8.3,1.5.8,1.9.5.5,1.1.8,1.9.8.7,0,1.4-.3,1.9-.8.4-.4.7-1.1.7-1.9c0-.7-.3-1.4-.7-1.8-.5-.5-1.2-.8-1.9-.8-.8,0-1.4.3-1.9.8-.5.4-.8,1.1-.8,1.8Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.7,512.9q.7.2,1.3.5.6.2,1.2.4.7.1,1.4.3.7.1,1.3.2q1,.2,1.8.5.9.3,1.7.8.4.2.7.5.3.2.6.6.2.2.4.4.1.2.3.4c0,0,.1.1.3.2.1.2.2.3.2.4q0,0,0-.3q0-.2-.1-.7-.2-1-.6-2-.4-.9-.9-1.7c-.8-1.1-1.9-1.9-3.2-2.5-1.2-.5-2.6-.9-3.9-.9-.5,0-1,0-1.3.2-.4.2-.7.5-.9,1q-.1.4-.2.8-.1.5-.1.9Z",
    fill: "url(#e7VyGK2MPtc178-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.8,518q-.2-.2-.4-.3-.2-.2-.5-.4-.2-.1-.4-.3-.3-.2-.5-.3-.4-.3-.9-.5-.4-.2-.8-.4c-1-.3-1.9-.5-2.8-.7-.9-.1-1.8-.2-2.7-.3q-.6,0-1.1-.1-.6-.1-1.1-.4-.3-.1-.6-.4-.2-.2-.3-.5-.1-.1-.1-.3-.1-.1-.1-.3-.1-.1-.1-.2t-.1-.4q.5.4,1.1.6.7.2,1.3.4.7.1,1.4.3.7.1,1.4.3c1.1.2,2.2.4,3.2.7s2,.8,2.8,1.6c.2.2.4.4.6.6.2.3.3.5.5.8q.1.2.2.3.1.2,0,.2Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618,516.2q-.2.2-.1.5t.4.4q.2.1.5,0t.4-.3q.1-.3.1-.6-.1-.2-.4-.4-.3-.1-.5,0-.3.1-.4.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.9,516.1q-.1.3,0,.5q0,.3.3.4t.5.1q.3-.1.4-.4.2-.3.1-.5-.1-.3-.4-.4-.2-.2-.5-.1t-.4.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M631.1,544.1c0,.1,0,.3.1.4.1.2.1.3.1.3.3.4.7.7,1.1,1s.8.5,1.1.7q.5.3,1.2.5.6.3,1.2.4t1.2.1q.6.1,1.2,0q1.3-.1,2.4-.4q1.1-.4,2.1-1.1.8-.6,1.3-1.4.5-.7.7-1.6.2-.6.3-1.2t.1-1.2q.1-.5.2-1.1q0-.5-.1-1c-.1-.1-.1-.2-.2-.3c0-.1-.1-.1-.2-.1s-.2.2-.2.3c-.1.2-.1.4-.2.5-.6,1-1.4,1.8-2.3,2.6-.9.7-2,1.3-3.1,1.8-1.3.5-2.6.8-3.9.9-1.4.1-2.7,0-4.1-.1Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.1,544.8q0,.4.1.9.1.4.2.8.1.2.2.5.1.2.3.4.6.1,1.2.1.6.1,1.2,0q1.3-.1,2.4-.4q1.1-.4,2.1-1.1c.8-.6,1.4-1.5,1.8-2.4.4-1,.7-2,.7-3q.1-.3.1-.7q0-.3,0-.6c0-.2,0-.4-.1-.7c0-.2-.1-.4-.2-.5q-.1-.1-.1-.1t-.1,0q0,.1-.1.2t-.1.1q-.4.6-.8,1.1-.4.6-.9,1.1t-1.1.9q-.6.5-1.3.8-1.2.7-2.6,1.1-1.3.4-2.7.6-.1.2-.1.4-.1.2-.1.5Z",
    fill: "url(#e7VyGK2MPtc184-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.6,537.3q0-.1,0-.2q0,0,0-.1t0-.2q0,0,0-.1t-.1-.3q0-.1-.1-.3-.1-.1-.1-.3-.1-.1-.3-.2-.2-.2-.5-.3t-.6,0q-.2,0-.4,0-.1,0-.3.1-.1,0-.1,0-.1.1-.2.1-.1.1-.2.1-.1.1-.1.1c0,0,.3,0,.5,0c.3,0,.7.1.9.1q.4.2.7.4.3.1.5.4.1.2.3.3.1.2.1.4Z",
    fill: "url(#e7VyGK2MPtc185-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.8,543.4c0,0,0,.3.1.6s.2.6.4.8q1,.1,1.9.1q1,0,1.9-.1.4,0,.7-.1.3,0,.6,0q1.2-.2,2.4-.7q1.2-.4,2.2-1.1.3-.1.6-.3t.6-.4q.7-.5,1.3-1.1.5-.7,1-1.5.1-.3.3-.7t.3-.7q0-.1-.1-.2t-.2-.1c-.5.9-1.2,1.8-2.1,2.6-.8.7-1.8,1.3-2.8,1.8q-1.1.4-2.2.7-1.2.3-2.4.4-.3.1-.7.1-.3,0-.6,0-.4.1-.8.1t-.8,0-.8-.1q-.4,0-.8-.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.8,543.4q.1.2.1.3.1,0,.1.2.3,0,.5,0q.2.1.4.1.8,0,1.5.1.7,0,1.5,0q1.6,0,3.1-.3q1.5-.4,3-.9.3-.1.6-.3t.6-.4q.7-.5,1.3-1.1.5-.7,1-1.5.1-.3.3-.7t.3-.7q0-.1-.1-.2t-.2-.1c-.5.9-1.2,1.8-2.1,2.6-.8.7-1.8,1.3-2.8,1.8q-1.1.4-2.2.7-1.2.3-2.4.4-.3.1-.7.1-.3,0-.6,0-.8.1-1.6.1-.8-.1-1.6-.2Z",
    fill: "url(#e7VyGK2MPtc187-fill)"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#bc4d4d"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.274542 0 0 0.269248-79.055698-50.861715)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M896.5,309.5c0,29-23.6,52.5-52.6,52.5s-52.6-23.5-52.6-52.5s23.6-52.6,52.6-52.6s52.6,23.6,52.6,52.6Z",
    fill: "#a8c7bf"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M879.6,310.1c0,19.6-15,35.4-33.4,35.4s-33.3-15.8-33.3-35.4c0-19.5,14.9-35.4,33.3-35.4s33.4,15.9,33.4,35.4Z",
    fill: "#bc4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876,310.1c0,19.6-14.9,35.4-33.3,35.4s-33.3-15.8-33.3-35.4c0-19.5,14.9-35.4,33.3-35.4s33.3,15.9,33.3,35.4Z",
    fill: "#d25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.4,310.1c0,13.4-10.2,24.2-22.7,24.2s-22.7-10.8-22.7-24.2c0-13.3,10.2-24.1,22.7-24.1s22.7,10.8,22.7,24.1Z",
    fill: "#faf2ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.4,310.1c0,5.8-4.3,10.4-9.7,10.4s-9.7-4.6-9.7-10.4c0-5.7,4.3-10.3,9.7-10.3s9.7,4.6,9.7,10.3Z",
    fill: "#d25a5a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M873.5,311.3q-.1,0-.1,0c-.4,0-.7-.4-.7-.8c0-.1.4-4.5-1.3-10-.1-.5.2-.9.6-1s.8.1.9.5c1.8,5.9,1.4,10.4,1.4,10.6-.1.4-.4.7-.8.7Z",
    fill: "#ffab9f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M869.1,293.6c-.3,0-.6-.2-.7-.4-1.2-2.1-2.7-4.1-4.3-5.8-9.2-9.8-22-9.3-22.1-9.3-.5,0-.8-.3-.8-.8-.1-.4.3-.7.7-.8.6,0,13.7-.5,23.4,9.9c1.7,1.8,3.2,3.8,4.4,6c.2.4.1.9-.3,1.1q-.1.1-.3.1Z",
    fill: "#ffab9f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M839.6,343.2q-.1,0-.1,0c-14-.2-22.2-13.6-22.6-14.2-.2-.4-.1-.8.3-1.1.4-.2.8-.1,1.1.3c0,.1,8.1,13.2,21.3,13.4.4,0,.7.4.7.8s-.3.8-.7.8Z",
    fill: "#ffab9f"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.7,454.8l-3-.7c0,0,.3-1.4,1-3.8l3,.8c-.7,2.4-1,3.7-1,3.7Z",
    fill: "#a8c7bf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M371.1,443.6l-3-1c.9-2.4,1.8-5,2.7-7.5l3,1.1c-1,2.5-1.9,5-2.7,7.4Zm5.5-14.8l-2.9-1.2c1-2.5,2.1-4.9,3.2-7.4l2.9,1.3c-1.1,2.4-2.2,4.9-3.2,7.3Zm6.5-14.5l-2.9-1.4c1.2-2.3,2.3-4.8,3.6-7.2l2.8,1.5c-1.2,2.3-2.4,4.7-3.5,7.1Zm7.1-14.1l-2.7-1.5c1.3-2.4,2.6-4.7,3.9-7l2.7,1.5c-1.3,2.3-2.6,4.6-3.9,7Zm8-13.8l-2.7-1.6c1.4-2.3,2.8-4.5,4.2-6.8l2.7,1.7c-1.5,2.2-2.9,4.5-4.2,6.7Zm8.6-13.3l-2.6-1.7c1.5-2.2,3-4.4,4.6-6.6l2.5,1.9c-1.5,2.1-3,4.3-4.5,6.4Zm9.3-12.8l-2.5-1.9c1.6-2.1,3.3-4.2,4.9-6.3l2.5,2c-1.7,2-3.3,4.1-4.9,6.2Zm10-12.3l-2.4-2c1.7-2.1,3.5-4.1,5.3-6l2.3,2.1c-1.8,1.9-3.5,3.9-5.2,5.9Zm10.6-11.7l-2.3-2.2c1.9-1.9,3.7-3.8,5.6-5.7l2.2,2.2c-1.8,1.9-3.7,3.8-5.5,5.7Zm11.2-11.2l-2.1-2.2c1.9-1.9,3.9-3.7,5.9-5.4l2.1,2.3c-2,1.8-3.9,3.6-5.9,5.3Zm11.9-10.4l-2-2.4c2-1.7,4.1-3.4,6.2-5.1l2,2.5c-2.1,1.6-4.2,3.3-6.2,5Zm12.4-9.8l-1.8-2.5c2.1-1.6,4.3-3.2,6.5-4.7l1.8,2.5c-2.2,1.5-4.3,3.1-6.5,4.7Zm13-9.1l-1.7-2.6c2.2-1.5,4.5-2.9,6.7-4.3l1.7,2.6c-2.3,1.4-4.5,2.9-6.7,4.3Zm13.5-8.3l-1.6-2.7c2.3-1.4,4.6-2.7,7-4l1.5,2.8c-2.3,1.2-4.7,2.5-6.9,3.9Zm13.9-7.6l-1.5-2.8c2.4-1.2,4.8-2.4,7.2-3.5l1.4,2.8c-2.4,1.1-4.8,2.3-7.1,3.5Zm267.1-.2c-2.3-1.2-4.6-2.3-7.1-3.5l1.3-2.8c2.5,1.1,4.9,2.3,7.2,3.5l-1.4,2.8Zm-252.8-6.6l-1.3-2.9c2.4-1,4.9-2.1,7.4-3.1l1.2,2.9c-2.5,1-4.9,2-7.3,3.1Zm238.5-.1c-2.4-1.1-4.8-2.1-7.3-3.1l1.2-2.9c2.5,1,4.9,2,7.4,3.1l-1.3,2.9Zm-223.9-5.9l-1.1-2.9c2.4-1,5-1.9,7.5-2.8l1,3c-2.5.8-5,1.8-7.4,2.7Zm209.2,0c-2.5-.9-5-1.8-7.5-2.7l1-2.9c2.5.8,5.1,1.7,7.6,2.6l-1.1,3Zm-15-5.1c-2.6-.8-5.1-1.5-7.6-2.2l.8-3.1c2.6.8,5.1,1.5,7.7,2.3l-.9,3Zm-179.3-.1l-.9-3c2.5-.8,5.1-1.6,7.6-2.3l.9,3c-2.5.7-5.1,1.5-7.6,2.3Zm164.1-4.2c-2.6-.7-5.2-1.3-7.7-1.9l.7-3.1c2.6.6,5.2,1.3,7.7,1.9l-.7,3.1Zm-148.8-.2l-.8-3c2.6-.7,5.2-1.3,7.8-1.9l.7,3c-2.6.6-5.1,1.3-7.7,1.9Zm133.4-3.3c-2.6-.5-5.2-1-7.8-1.5l.6-3.1c2.6.5,5.2,1,7.8,1.5l-.6,3.1Zm-117.9-.3l-.7-3c2.6-.6,5.3-1.1,7.9-1.5l.5,3.1c-2.5.4-5.2.9-7.7,1.4Zm102.3-2.5c-2.6-.4-5.2-.7-7.8-1l.4-3.2c2.6.4,5.3.7,7.9,1.1l-.5,3.1Zm-86.8-.2l-.4-3.1c2.6-.4,5.3-.8,7.9-1.1l.4,3.1c-2.6.3-5.3.7-7.9,1.1Zm71.1-1.7c-2.6-.3-5.3-.5-7.9-.7l.2-3.1c2.7.2,5.3.4,8,.7l-.3,3.1Zm-55.3-.2l-.3-3.2c2.6-.2,5.3-.4,7.9-.6l.2,3.2c-2.6.1-5.2.3-7.8.6Zm39.5-1c-2.6-.1-5.3-.2-7.9-.2v-3.1c2.7,0,5.4.1,8,.2l-.1,3.1Zm-23.7-.1l-.1-3.1c2.6-.1,5.3-.2,8-.2v3.1c-2.6.1-5.3.1-7.9.2Z",
    fill: "#a8c7bf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M790,285.3c0,0-1.2-.7-3.3-1.9l1.5-2.7c2.2,1.2,3.4,1.9,3.5,2l-1.7,2.6Z",
    fill: "#a8c7bf"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M390,508.1c0,29-23.5,52.5-52.6,52.5-29,0-52.5-23.5-52.5-52.5s23.5-52.6,52.5-52.6c29.1,0,52.6,23.6,52.6,52.6Z",
    fill: "#f09280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.9,311.2c0,29-23.5,52.5-52.6,52.5-29,0-52.5-23.5-52.5-52.5s23.5-52.6,52.5-52.6c29.1,0,52.6,23.6,52.6,52.6Z",
    fill: "#43766a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.1,244.1c0,29.1-23.5,52.6-52.6,52.6-29,0-52.5-23.5-52.5-52.6c0-29,23.5-52.5,52.5-52.5c29.1,0,52.6,23.5,52.6,52.5Z",
    fill: "#ffe0ac"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M334.7,509c2.9.6,13.1,15.4,13.1,15.4l1.2-.8c0,0-9.6-15-9.4-17.9l-4.9,3.3Z",
    fill: "#ffcf83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.8,540.7l19.8-13.6c0,0-13.6-6.5-17.2-4-3.5,2.4-2.6,17.6-2.6,17.6Z",
    fill: "#ffcf83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.7,500.3c6.8,5.5,16.6,10.7,25.8,6.5c5.9-6.5,4.1-17.1,1.4-25.2l-27.2,18.7Z",
    fill: "#ffcf83"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.3,509.5c-14.4,0-27.7-16.1-28.4-16.9-.2-.3-.3-.6-.2-.9c0-.4.2-.7.5-.9l31.2-21.3c.2-.2.6-.3.9-.2s.6.3.8.6c.6,1,14.3,25.6,3.2,37.7q-.1.1-.3.2c-2.6,1.2-5.2,1.7-7.7,1.7ZM304.6,492c3.7,4.2,18.8,19.8,32.1,13.8c8.5-9.5-.6-28.8-3.1-33.6l-29,19.8Z",
    fill: "#faf2ec"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M338.8,545.4q-.2,0-.3,0c-.3-.1-.6-.3-.8-.6-.6-1.1-14.7-26.2-1.2-39.1q.1-.2.4-.3c15.3-6,33.2,15.8,34,16.7.2.2.3.6.2.9c0,.3-.2.6-.5.8l-31.2,21.4q-.3.2-.6.2Zm-.9-37.8c-10.3,10.2-1.2,30,1.3,34.9l29-19.9c-3.6-4.1-18.3-19.5-30.3-15Z",
    fill: "#faf2ec"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.2,469.7l-37.5,25.8-3.7-5.4l37.5-25.7l3.7,5.3Z",
    fill: "#faf2ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.3,525.3L338.8,551l-3.7-5.4l37.5-25.7l3.7,5.4Z",
    fill: "#faf2ec"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M332.4,503.9q-1.8,0-3.8-.4c-.5-.1-.9-.6-.8-1.2.1-.5.7-.9,1.2-.8q2.7.6,5.2.3c.5-.1,1,.3,1.1.9.1.5-.3,1-.9,1.1q-1,.1-2,.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M322.9,501.4q-.2,0-.4-.1c-6.3-3.1-10.7-8-10.9-8.2-.4-.4-.4-1.1,0-1.5.5-.3,1.1-.3,1.5.1c0,.1,4.4,4.8,10.3,7.8.5.2.7.9.4,1.4-.1.3-.5.5-.9.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M341.6,538.1c-.4,0-.7-.2-.9-.6-.1-.1-1.9-3.9-2.9-8.6-.2-.6.2-1.1.7-1.2.6-.2,1.1.2,1.3.7c1,4.5,2.7,8.2,2.7,8.3.3.5.1,1.1-.4,1.3q-.3.1-.5.1Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M485.5,293.2l-69.4,12.9L414,295l69.4-12.9l2.1,11.1Z",
    fill: "#a8c7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.8,327.3l-69.4,12.9-6.6-35.7l69.4-12.9l6.6,35.7Z",
    fill: "#faf2ec"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M427.5,313.7l-5.4,1-1-5.3l5.4-1l1,5.3Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.4,312.3l-5.4,1-1-5.4l5.4-1l1,5.4Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.3,310.8l-5.4,1-.9-5.4l5.3-1l1,5.4Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.2,309.3l-5.3,1-1-5.4l5.3-1l1,5.4Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.2,307.8l-5.4,1-1-5.3l5.4-1l1,5.3Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.1,306.4l-5.4,1-1-5.4l5.4-1l1,5.4Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475,304.9l-5.3,1-1-5.4l5.3-1l1,5.4Z",
    fill: "#f09280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483,303.4l-5.4,1-1-5.4l5.4-1l1,5.4Z",
    fill: "#f09280"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M429.2,323.3l-5.3,1-1-5.4l5.3-1l1,5.4Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.2,321.8l-5.4,1-1-5.3l5.4-1l1,5.3Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.1,320.3l-5.4,1-1-5.3l5.4-1l1,5.3Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,318.9l-5.3,1-1-5.4l5.3-1l1,5.4Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,317.4l-5.4,1-1-5.4l5.4-1l1,5.4Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.9,315.9l-5.4,1-1-5.3l5.4-1l1,5.3Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.8,314.4l-5.3,1-1-5.3l5.3-1l1,5.3Z",
    fill: "#f09280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.7,313l-5.3,1-1-5.4l5.3-1l1,5.4Z",
    fill: "#f09280"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M431,332.9l-5.4,1-1-5.4l5.4-1l1,5.4Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.9,331.4l-5.3,1-1-5.4l5.3-1l1,5.4Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.9,329.9l-5.4,1-1-5.4l5.4-1l1,5.4Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.8,328.4l-5.4,1-1-5.3l5.4-1l1,5.3Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.7,327l-5.3,1-1-5.4l5.3-1l1,5.4Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.7,325.5l-5.4,1-1-5.4l5.4-1l1,5.4Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.6,324l-5.4,1-1-5.4l5.4-1l1,5.4Z",
    fill: "#f09280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.5,322.5l-5.3,1-1-5.3l5.3-1l1,5.3Z",
    fill: "#f09280"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M422.9,297.2c.3,1.3-.6,2.5-1.8,2.8-1.3.2-2.5-.6-2.8-1.9-.2-1.3.6-2.5,1.9-2.8c1.3-.2,2.5.7,2.7,1.9Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M420.6,298.6c-.4,0-.8-.3-.8-.7l-1.4-7.4c-.1-.5.2-1,.7-1.1s1,.2,1.1.7l1.3,7.5c.1.5-.2.9-.7,1q-.1,0-.2,0Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M429.3,296c.3,1.3-.6,2.5-1.8,2.8-1.3.2-2.5-.6-2.8-1.9-.2-1.3.6-2.5,1.9-2.7c1.3-.3,2.5.6,2.7,1.8Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M427,297.4c-.4,0-.8-.3-.9-.7l-1.3-7.4c-.1-.5.2-1,.7-1.1s1,.2,1,.7l1.4,7.5c.1.5-.2.9-.7,1q-.1,0-.2,0Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M474.1,287.7c.2,1.3-.6,2.5-1.9,2.7-1.3.3-2.5-.6-2.7-1.8-.2-1.3.6-2.5,1.9-2.8c1.2-.2,2.5.6,2.7,1.9Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M471.8,289.1c-.4,0-.8-.3-.9-.7l-1.4-7.5c-.1-.5.3-.9.8-1s.9.2,1,.7l1.4,7.4c.1.5-.2,1-.7,1.1q-.1,0-.2,0Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M480.5,286.5c.2,1.3-.6,2.5-1.9,2.8-1.3.2-2.5-.6-2.7-1.9-.3-1.3.6-2.5,1.9-2.8c1.2-.2,2.5.6,2.7,1.9Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M478.2,287.9c-.4,0-.8-.3-.9-.7l-1.4-7.4c-.1-.5.3-1,.8-1.1.4-.1.9.2,1,.7l1.4,7.5c.1.5-.2.9-.7,1q-.1,0-.2,0Z",
    fill: "#625153"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M675.3,287.2l-46.8-28.8l31-50l46.8,28.8-31,50Z",
    fill: "#386358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.4,286l-44-27.1l31.8-50.6l44.3,26.2L673.4,286Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.9,284.5l-42.4-26.2L661.6,205l42.3,26.1-33,53.4Z",
    fill: "#43766a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M660.1,213.5q-.3,0-.6-.1l-7.2-4.5c-.5-.3-.7-1-.4-1.5s1-.6,1.5-.3l7.3,4.5c.5.3.6.9.3,1.4-.2.4-.6.5-.9.5Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M654,223.4q-.3,0-.6-.2l-7.2-4.5c-.5-.3-.7-1-.4-1.5.4-.5,1-.6,1.5-.3l7.3,4.5c.5.3.6,1,.3,1.5-.2.3-.5.5-.9.5Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M647.9,233.2q-.3,0-.5-.2l-7.3-4.5c-.5-.3-.6-.9-.3-1.4s.9-.7,1.5-.4l7.2,4.5c.5.3.7,1,.3,1.5-.2.3-.5.5-.9.5Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M641.9,243q-.3,0-.6-.2l-7.3-4.4c-.5-.3-.6-1-.3-1.5s1-.7,1.5-.4l7.2,4.5c.5.3.7,1,.4,1.5-.2.3-.6.5-.9.5Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M635.8,252.8q-.3,0-.6-.1l-7.2-4.5c-.5-.3-.7-1-.4-1.5s1-.7,1.5-.3l7.2,4.4c.6.4.7,1,.4,1.5-.2.3-.6.5-.9.5Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M679.4,252.9l-25.6-15.8l10.7-17.3l25.6,15.8-10.7,17.3Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.3,264.3l-25.6-15.8l4.6-7.3L676.8,257l-4.5,7.3Z",
    fill: "#f2e9e2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M697.5,232q-.2,0-.4-.1l-6.4-3.9c-.4-.3-.5-.7-.3-1.1s.7-.5,1.1-.3l6.4,3.9c.4.2.5.7.2,1.1-.1.2-.4.4-.6.4Z",
    fill: "#a6c1b2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M684.8,224.2q-.3,0-.5-.1l-18.6-11.3c-.4-.3-.5-.7-.3-1.1.3-.4.7-.5,1.1-.3l18.7,11.4c.3.2.5.7.2,1.1-.1.2-.4.3-.6.3Z",
    fill: "#a6c1b2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M844.5,312.2c-.3,0-.5-.1-.8-.4l-48.3-49.9c-.4-.4-.4-1.1,0-1.5s1.1-.4,1.5,0l48.4,50c.4.4.4,1.1,0,1.5-.2.2-.5.3-.8.3Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M797.5,263.1q-.1,0-.2-.1l-10.1-1.8c-.6-.1-1-.7-.9-1.3s.7-1,1.3-.8l10.1,1.8c.6.1.9.7.8,1.3-.1.5-.5.9-1,.9Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M800.8,267.3q-.1,0-.3,0l-10.2-2.2c-.5-.1-.9-.7-.8-1.3.1-.5.7-.9,1.3-.8l10.2,2.2c.6.1.9.7.8,1.3-.1.5-.5.8-1,.8Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M804.6,271.4q-.2,0-.3,0L793.4,269c-.6-.1-1-.7-.9-1.3.2-.5.7-.9,1.3-.8l11,2.4c.6.1.9.7.8,1.3-.1.5-.5.8-1,.8Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M804.6,271.4c-.6,0-1.1-.5-1.1-1l-.3-11c-.1-.6.4-1.1,1-1.1q0,0,0,0c.6,0,1.1.4,1.1,1l.3,11c0,.6-.4,1.1-1,1.1q0,0,0,0Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M800.9,267.3q0,0,0,0c-.6,0-1.1-.5-1.1-1.1l.1-10c0-.6.5-1.1,1.1-1.1q0,0,0,0c.6.1,1.1.5,1.1,1.1l-.1,10c-.1.6-.5,1.1-1.1,1.1Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M797.5,263.1q0,0,0,0c-.6,0-1.1-.5-1.1-1.1l.2-9.4c0-.6.5-1.1,1.1-1.1.6.1,1.1.5,1.1,1.1l-.2,9.4c-.1.6-.5,1.1-1.1,1.1Z",
    fill: "#625153"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M446.3,442.7c0-.8.7-1.5,1.5-1.5",
    fill: "#a8c7bf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#f09280"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ffcf83"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M898.1,417.6h-20.2c-1.1,0-1.9-.8-1.9-1.9c0-1,.8-1.9,1.9-1.9h20.2c1,0,1.9.9,1.9,1.9c0,1.1-.9,1.9-1.9,1.9Z",
    fill: "#fff9f4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M860.2,417.6h-74.5c-1.1,0-1.9-.8-1.9-1.9c0-1,.8-1.9,1.9-1.9h74.5c1.1,0,1.9.9,1.9,1.9c0,1.1-.8,1.9-1.9,1.9Z",
    fill: "#fff9f4"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#bc4d4d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime2);
export default __webpack_public_path__ + "static/media/time-2.954db420a294f8d6ea25c6e54a527c78.svg";
export { ForwardRef as ReactComponent };